import ko from 'knockout'
import template from './resulted.image.tpl.html'
import { IResultedImageViewModelParams, ResultedImageViewModel } from './ResultedImageViewModel'

if (!ko.components.isRegistered('resulted-image')) {
  ko.components.register('resulted-image', {
    viewModel: {
      createViewModel: (params: IResultedImageViewModelParams) => {
        const viewModel = new ResultedImageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
